import { Button } from '@/components/ui/button';
import { FlexCol } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { BookOpen, Plus } from 'lucide-react';
import { FC } from 'react';

interface EmptyStateProps {
  onCreateReview: () => void;
}

export const EmptyState: FC<EmptyStateProps> = ({ onCreateReview }) => {
  return (
    <FlexCol
      p="4"
      className="border-2 border-dashed border-neutral-200 rounded-lg bg-white w-full"
      alignItems="center"
      justifyContent="center"
      gap="4"
    >
      <BookOpen className="h-10 w-10 bg-neutral-100 rounded-md p-3" />
      <FlexCol gap="2" alignItems="center" justifyContent="center">
        <Text variant="body-sm-bold">No literature reviews yet</Text>
        <Text className="text-gray-500" variant="body-sm">
          Create your first literature review to start organizing your research
        </Text>
      </FlexCol>
      <Button onClick={onCreateReview}>
        <Plus />
        Create Literature Review
      </Button>
    </FlexCol>
  );
};
